import React, { useState, useEffect, useRef } from 'react';
import { 
  Container, Row, Col, Card, Button, Form, InputGroup, 
  Badge, Alert, Modal, Spinner, ListGroup, Offcanvas,
  ButtonGroup
} from 'react-bootstrap';
import { 
  ShoppingCart, Search, Plus, Minus, Trash2, User, 
  Receipt, Check, X, Package, Calculator, Menu, Grid3x3,
  Printer, Eye, Phone, MapPin, // Icônes pour impression
  Unlock,
  Lock
} from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { useBoutique } from '../../contexts/BoutiqueContext';
import productService, { PRODUCT_TYPES } from '../../services/productService';
import customerService from '../../services/customerService';
import saleService from '../../services/saleService';
import offlineDB from '../../services/offlineDatabase';
import { useNavigate } from 'react-router-dom';
import TicketPrintService from '../../services/ticketPrintService'; // Import du service d'impression
import SaleInterfaceScanner from '../common/SaleInterfaceScanner';
import { canShowCredits } from '../../utils/creditHelper';
import MultiPaymentModal from './MultiPaymentModal';
import OpenSessionModal from '../cashSession/Opensessionmodal';
import CloseSessionModal from '../cashSession/Closesessionmodal';
import { cashSessionService } from '../../services/Cashsessionservice';



const SaleInterface = () => {
  const { user } = useAuth();
  const { currentBoutique, isRestaurantEnabled } = useBoutique();

  const searchRef = useRef(null);

  const navigate = useNavigate();

  const paymentMethods = saleService.getPaymentMethods();


  // État principal
  const [cart, setCart] = useState([]);
  const [products, setProducts] = useState([]);

  const [customers, setCustomers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  const [showMultiPaymentModal, setShowMultiPaymentModal] = useState(false);
  const [isMultiPaymentMode, setIsMultiPaymentMode] = useState(false);
  const [currentSaleTotal, setCurrentSaleTotal] = useState(0);
   // ✅ AJOUTER ICI - Hook offline
  // ✅ Offline désactivé - valeurs fixes
const isOnline = true;
const isOffline = false;
const createOfflineSale = async () => null;
const getOfflineProducts = async () => [];
const getOfflineCustomers = async () => [];
const getOfflineProductByBarcode = async () => null;



  
  // Client sélectionné
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customerName, setCustomerName] = useState('');
  const [customerAddress, setCustomerAddress] = useState('');
  const [customerPhone, setCustomerPhone] = useState('');
  const [showCustomerSuggestions, setShowCustomerSuggestions] = useState(false);
  const [showMobileCustomerSuggestions, setShowMobileCustomerSuggestions] = useState(false);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  
  // ✅ NOUVEAU : État revendeur pour création de client
  const [isNewCustomerReseller, setIsNewCustomerReseller] = useState(false);
  const [resellerDiscountAmount, setResellerDiscountAmount] = useState(3000);

  // Paiement
  const [paymentMethod, setPaymentMethod] = useState('CASH');
  const [discount, setDiscount] = useState(0);
  const [discountPercentage, setDiscountPercentage] = useState(0);

  const [discountInput, setDiscountInput] = useState('0'); // ✅ AJOUT: Input séparé pour la remise
  const [isCredit, setIsCredit] = useState(false);
  const [notes, setNotes] = useState('');


  
  // ✅ États sessions de caisse
const [currentSession, setCurrentSession] = useState(null);
const [showOpenSessionModal, setShowOpenSessionModal] = useState(false);
const [showCloseSessionModal, setShowCloseSessionModal] = useState(false);
const [sessionLoading, setSessionLoading] = useState(true);

  
  // Client sélectionné

  // États UI responsive
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [showCartOffcanvas, setShowCartOffcanvas] = useState(false);
  const [viewMode, setViewMode] = useState('grid');

  // États pour l'impression
  const [showPrintOptions, setShowPrintOptions] = useState(false);
  const [lastSaleData, setLastSaleData] = useState(null);
  const [printAfterSale, setPrintAfterSale] = useState(true);

  // Chargement initial
  useEffect(() => {
    loadProducts();
    loadCustomers();
    if (searchRef.current) {
      searchRef.current.focus();
    }
  }, []);

  // ✅ Recalculer le total quand le panier change
useEffect(() => {
  const total = calculateTotal();
  setCurrentSaleTotal(total);
}, [cart, discount]); // ✅ Dépendances qui affectent le total

// ✅ Recalculer les prix du panier quand le client change (revendeur existant OU nouveau client revendeur)
useEffect(() => {
  if (cart.length === 0) return;
  
  // Déterminer si c'est une vente revendeur
  // 1. Client existant revendeur
  // 2. OU nouveau client avec case revendeur cochée
  const isExistingReseller = selectedCustomer?.isReseller === true;
  const isNewReseller = !selectedCustomer && isNewCustomerReseller === true;
  const isResellerSale = isExistingReseller || isNewReseller;
  
  // Déterminer le montant de la remise
  let resellerDiscount = 0;
  if (isExistingReseller) {
    resellerDiscount = parseFloat(selectedCustomer?.resellerDiscount) || 0;
  } else if (isNewReseller) {
    resellerDiscount = parseFloat(resellerDiscountAmount) || 0;
  }
  
  // Vérifier si on doit recalculer les prix
  const needsRecalculation = cart.some(item => {
    const shouldHaveDiscount = isResellerSale && resellerDiscount > 0;
    const hasDiscount = item.hasResellerDiscount === true;
    const currentDiscountAmount = item.resellerDiscountAmount || 0;
    
    // Recalculer si:
    // 1. Le statut change (revendeur → non-revendeur ou inverse)
    // 2. Ou si le montant de remise est différent
    return shouldHaveDiscount !== hasDiscount || 
           (shouldHaveDiscount && currentDiscountAmount !== resellerDiscount);
  });
  
  if (needsRecalculation) {
    
    const updatedCart = cart.map(item => {
      // Déterminer le prix de base (avant remise revendeur)
      let basePrice;
      if (item.priceBeforeResellerDiscount && item.priceBeforeResellerDiscount > 0) {
        basePrice = item.priceBeforeResellerDiscount;
      } else if (item.hasPromo && item.promoPrice) {
        basePrice = item.promoPrice;
      } else {
        basePrice = item.originalPrice || item.price;
      }
      
      
      if (isResellerSale && resellerDiscount > 0) {
        // Appliquer la remise revendeur
        const newPrice = Math.max(1, basePrice - resellerDiscount);
        return {
          ...item,
          price: newPrice,
          totalPrice: newPrice * item.quantity,
          hasResellerDiscount: true,
          resellerDiscountAmount: resellerDiscount,
          priceBeforeResellerDiscount: basePrice
        };
      } else {
        // Pas de remise revendeur - revenir au prix de base
        return {
          ...item,
          price: basePrice,
          totalPrice: basePrice * item.quantity,
          hasResellerDiscount: false,
          resellerDiscountAmount: 0,
          priceBeforeResellerDiscount: basePrice
        };
      }
    });
    
    setCart(updatedCart);
    
    if (isResellerSale && resellerDiscount > 0) {
    } else {
    }
  }
}, [selectedCustomer, isNewCustomerReseller, resellerDiscountAmount]);

// ═════════════════════════
// 3. useEffect AU MOUNT — Vérifie la session si module Restaurant actif
// ═════════════════════════
// IMPORTANT: utilise ton context boutique pour savoir si le module est actif
// J'utilise `boutique` ou `currentBoutique` — adapte selon ton BoutiqueContext
 
useEffect(() => {
  const checkSession = async () => {
    console.log('🔍 checkSession démarre - isRestaurantEnabled:', isRestaurantEnabled);
    
    if (!isRestaurantEnabled) {
      setSessionLoading(false);
      return;
    }

    try {
      const response = await cashSessionService.getCurrentSession();
      console.log('📥 Réponse getCurrentSession:', response);

      if (response.success && response.data) {
        // ✅ Une session existe (OPEN ou LOCKED)
        console.log('✅ Session trouvée:', response.data.session_number);
        if (response.data.status === 'LOCKED') {
          alert(`Votre session est verrouillée (24h dépassées). Demandez au gestionnaire de la fermer.`);
        }
        setCurrentSession(response.data);
      } else {
        // ✅ Pas de session → afficher le modal d'ouverture
        console.log('🔴 Pas de session → setShowOpenSessionModal(true)');
        setShowOpenSessionModal(true);
      }
    } catch (e) {
      console.error('❌ Erreur vérification session:', e);
    } finally {
      setSessionLoading(false);
    }
  };

  checkSession();
}, [currentBoutique]);

 const loadProducts = async () => {
  try {
    setLoading(true);
    
    let productsData = [];
    
    // ✅ NOUVEAU : Utiliser le service offline
    if (isOffline) {
      productsData = await getOfflineProducts();
    } else {
      // Mode online - API normale
      const response = await productService.getProducts({
        size: 100,
        sortBy: 'name',
        sortDirection: 'ASC'
      });
      
      if (response.success) {
        if (Array.isArray(response.data)) {
          productsData = response.data;
        } else if (response.data && Array.isArray(response.data.content)) {
          productsData = response.data.content;
        } else if (response.data && Array.isArray(response.data.products)) {
          productsData = response.data.products;
        } else {
          productsData = [];
        }
      }
    }

    // Filtrer selon productAccessType
    const accessibleProducts = productsData.filter(product => {
      if (!user?.productAccessType || user.productAccessType === 'ALL') {
        return true;
      }
      if (user.productAccessType === 'STOCKABLE') {
        return product.productType === 'STOCKABLE';
      }
      if (user.productAccessType === 'SERVICE') {
        return product.productType === 'SERVICE';
      }
      return false;
    });

    const formattedProducts = accessibleProducts.map(productService.formatProductForSale);
    setProducts(formattedProducts);
    
  } catch (error) {
    console.error('❌ Erreur chargement produits:', error);
    setProducts([]);
    setError('Erreur lors du chargement des produits');
  } finally {
    setLoading(false);
  }
};

  const handleProductScanned = (product) => {
  
};

const handleMultiPayment = () => {
  const total = calculateTotal();
 
  
  if (cart.length === 0) {
    setError('Ajoutez des produits avant de configurer le paiement');
    return;
  }
  
  if (total <= 0) {
    setError('Le total doit être supérieur à 0');
    return;
  }
  
  // ✅ IMPORTANT: NE PAS utiliser setCurrentSaleTotal - utiliser directement calculateTotal()
  setShowMultiPaymentModal(true);
};

// ✅ Handlers sessions
const handleSessionOpened = (session) => {
  setCurrentSession(session);
  setShowOpenSessionModal(false);
};
 
const handleSessionClosed = (closedSession) => {
  setCurrentSession(null);
  setShowCloseSessionModal(false);
  // Réafficher le modal d'ouverture pour la prochaine session
  setShowOpenSessionModal(true);
};

const confirmMultiPayment = async (payments) => {
  try {
    setLoading(true);
    setError(null);
    
    
    const saleTotal = calculateTotal();
    
    if (saleTotal <= 0) {
      throw new Error('Le total de la vente doit être supérieur à 0');
    }
    
    // Vérifier que le total des paiements correspond
    const totalPayments = payments.reduce((sum, p) => sum + parseFloat(p.amount), 0);
    
    if (Math.abs(totalPayments - saleTotal) > 0.01) {
      throw new Error(`Le total des paiements (${totalPayments}) ne correspond pas au total de la vente (${saleTotal})`);
    }
    
    // ✅ CORRECTION FINALE: Format snake_case selon @JsonProperty du backend
    const saleRequest = {
      customer_name: customerName.trim() || 'Client Anonyme',    // ✅ snake_case
      customer_phone: customerPhone.trim() || null,             // ✅ snake_case
      payment_method: 'MIXED',                                  // ✅ snake_case
      is_credit: false,                                         // ✅ snake_case
      items: cart.map(item => {
        
        // Validation stricte avant envoi
        if (!item.productId) {
          throw new Error(`Article "${item.name}" n'a pas d'ID produit`);
        }
        if (!item.price || parseFloat(item.price) <= 0) {
          throw new Error(`Article "${item.name}" n'a pas de prix valide`);
        }
        if (!item.quantity || parseInt(item.quantity) <= 0) {
          throw new Error(`Article "${item.name}" n'a pas de quantité valide`);
        }
        
        return {
          product_id: item.productId,                            // ✅ camelCase (pas de @JsonProperty dans SaleItemDto)
          quantity: parseInt(item.quantity),
          unit_price: parseFloat(item.price)
        };
      }),
      discount: parseFloat(discount) || 0,
      tax: 0,
      notes: notes.trim() || null
    };
    
    const multiPayment = {
      payments: payments.map(payment => ({
        method: payment.method,
        amount: parseFloat(payment.amount),
        reference: payment.reference?.trim() || null,
        notes: payment.notes?.trim() || null
      })),
      expectedTotal: saleTotal
    };
    
    // Payload final
    const requestData = {
      saleRequest: saleRequest,
      multiPayment: multiPayment
    };
    
    
    // ✅ Debug des champs critiques avec les VRAIS noms envoyés
    
    
    if (saleRequest.items.length > 0) {
      
    }
    
    // Envoi au backend
    const response = await saleService.createSaleWithMultiPayment(requestData);
    
    if (response.success) {
      setSuccess('Vente créée avec paiements multiples avec succès !');
      
      // Reset formulaire
      setCart([]);
      setCustomerName('');
      setCustomerPhone('');
      setSelectedCustomer(null);
      setPaymentMethod('CASH');
      setIsCredit(false);
      setDiscount(0);
      setDiscountInput('0');
      setNotes('');
      setSearchTerm('');
      setShowMultiPaymentModal(false);
      
      await loadProducts();
      
     navigate('/sales'); // Rediriger vers la liste des ventes
      
    } else {
      throw new Error(response.message || 'Erreur lors de la création');
    }
    
  } catch (error) {
    console.error('❌ Erreur création vente multi-paiement:', error);
    setError(error.message || 'Erreur lors de la création de la vente');
  } finally {
    setLoading(false);
  }
};

const resetSaleForm = () => {
  setCart([]);
  setCustomerName('');
  setCustomerPhone('');
  setSelectedCustomer(null);
  setDiscount(0);
  setNotes('');
  setPaymentMethod('CASH');
  setIsCredit(false);
  setIsMultiPaymentMode(false);
};


  // Chargement des clients
 const loadCustomers = async () => {
  try {
    
    let customersData = [];
    
    // ✅ NOUVEAU : Utiliser le service offline
    if (isOffline) {
      customersData = await getOfflineCustomers();
    } else {
      const response = await customerService.getCustomers();
      if (response.success) {
        customersData = response.data;
      }
    }
    
    const formattedCustomers = customersData.map(customer => 
      customerService.formatCustomerForDisplay(customer)
    );
    setCustomers(formattedCustomers);
    
  } catch (error) {
    console.error('❌ Erreur chargement clients:', error);
    setCustomers([]);
  }
};

  // Filtrage des produits
  const getFilteredProducts = () => {
    if (!Array.isArray(products)) return [];
    
    if (searchTerm.trim()) {
      return products.filter(product =>
        product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (product.sku && product.sku.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (product.barcode && product.barcode.includes(searchTerm))
      );
    }
    return products;
  };

  // Gestion du panier
  const addToCart = (product) => {
  
  const isService = product.productType === PRODUCT_TYPES.SERVICE || 
                   product.productType === 'SERVICE' ||
                   product.isService === true;

  const stockValue = isService ? Infinity : (product.stock || product.currentStock || 0);
  
  // Validation du stock pour les produits STOCKABLE uniquement
  if (!isService && stockValue <= 0) {
    setError('Produit en rupture de stock');
    setTimeout(() => setError(null), 3000);
    return;
  }

  // Prix de base (promo si disponible)
  const hasPromo = product.hasPromo || false;
  let basePrice = (hasPromo && product.promoPrice) ? product.promoPrice : product.price;
  let effectivePrice = basePrice;
  
  // ✅ Appliquer la remise revendeur si:
  // 1. Client existant revendeur sélectionné
  // 2. OU nouveau client avec case revendeur cochée
  let resellerDiscountApplied = 0;
  const isExistingReseller = selectedCustomer?.isReseller === true;
  const isNewReseller = !selectedCustomer && isNewCustomerReseller === true;
  const isResellerSale = isExistingReseller || isNewReseller;
  
  if (isResellerSale) {
    let resellerDiscount = 0;
    if (isExistingReseller) {
      resellerDiscount = parseFloat(selectedCustomer.resellerDiscount) || 0;
    } else if (isNewReseller) {
      resellerDiscount = parseFloat(resellerDiscountAmount) || 0;
    }
    
    if (resellerDiscount > 0) {
      resellerDiscountApplied = resellerDiscount;
      effectivePrice = Math.max(1, basePrice - resellerDiscount); // Minimum 1 FCFA
    }
  }

  const existingItem = cart.find(item => item.productId === product.id);
  
  if (existingItem) {
    if (isService || existingItem.quantity < stockValue) {
      setCart(cart.map(item =>
        item.productId === product.id
          ? { 
              ...item, 
              quantity: item.quantity + 1,
              totalPrice: (item.quantity + 1) * item.price
            }
          : item
      ));
    } else {
      setError('Stock insuffisant');
      setTimeout(() => setError(null), 3000);
    }
  } else {
    const cartItem = {
      productId: product.id,
      name: product.name,
      price: effectivePrice, // Prix après promo ET remise revendeur
      originalPrice: product.price, // Prix original sans aucune remise
      priceBeforeResellerDiscount: basePrice, // Prix avant remise revendeur (après promo si applicable)
      quantity: 1,
      totalPrice: effectivePrice,
      stock: isService ? null : stockValue,
      imageUrl: product.imageUrl,
      categoryName: product.categoryName,
      // Informations sur le type
      productType: product.productType || 'STOCKABLE',
      isService: isService,
      isStockable: !isService,
      typeIcon: isService ? '🔧' : '📦',
      typeLabel: isService ? 'Service' : 'Produit',
      // Informations sur la promo
      hasPromo: hasPromo,
      promoPrice: product.promoPrice || null,
      discountPercentage: product.discountPercentage || null,
      activePromotionName: product.activePromotionName || null,
      // Informations remise revendeur
      hasResellerDiscount: resellerDiscountApplied > 0,
      resellerDiscountAmount: resellerDiscountApplied
    };
    
    setCart([...cart, cartItem]);
    
    // Log détaillé
    if (hasPromo && resellerDiscountApplied > 0) {
    } else if (hasPromo) {
    } else if (resellerDiscountApplied > 0) {
    } else {
    }
  }

  // Ouvrir le panier sur mobile
  if (window.innerWidth < 992) {
    setShowCartOffcanvas(true);
  }

  // setSearchTerm('');
  // setF(products.slice(0, 20));
  // if (searchRef.current) {
  //   searchRef.current.focus();
  // }
};

  const updateCartQuantity = (productId, newQuantity) => {
    if (newQuantity <= 0) {
      removeFromCart(productId);
      return;
    }

    const item = cart.find(item => item.productId === productId);
    if (item && newQuantity <= item.stock) {
      setCart(cart.map(item =>
        item.productId === productId
          ? { ...item, quantity: newQuantity }
          : item
      ));
    } else {
      setError('Quantité demandée supérieure au stock disponible');
      setTimeout(() => setError(null), 3000);
    }
  };

  const removeFromCart = (productId) => {
    setCart(cart.filter(item => item.productId !== productId));
  };

  /**
 * ✅ NOUVEAU : Gérer le changement de mode de paiement
 * Mettre automatiquement isCredit à true si CREDIT est sélectionné
 */
const handlePaymentMethodChange = (method) => {
  
  setPaymentMethod(method);
  
  // ✅ Si on sélectionne CREDIT, activer automatiquement isCredit
  if (method === 'CREDIT') {
    setIsCredit(true);
  } else {
    // ✅ Si on change vers un autre mode, désactiver isCredit
    setIsCredit(false);
  }
};

  // Gestion des clients
  const handleCustomerNameChange = (value) => {
    setCustomerName(value);
    setCustomerPhone(''); // AJOUTER cette ligne
    setCustomerAddress(''); // AJOUTER cette ligne
    setSelectedCustomer(null);
    
    if (value.trim().length >= 2) {
      const filtered = customers.filter(customer =>
        customer.name.toLowerCase().includes(value.toLowerCase()) ||
        (customer.phone && customer.phone.includes(value))
      );
      setFilteredCustomers(filtered);
      setShowCustomerSuggestions(filtered.length > 0);
      setShowMobileCustomerSuggestions(filtered.length > 0);
    } else {
      setFilteredCustomers([]);
      setShowCustomerSuggestions(false);
      setShowMobileCustomerSuggestions(false);
    }
  };

  const handleSelectCustomer = (customer) => {
    setSelectedCustomer(customer);
    setCustomerName(customer.name);
    setCustomerPhone(customer.phone || '');
    setCustomerAddress(customer.address || '');
    setShowCustomerSuggestions(false);
    setShowMobileCustomerSuggestions(false);
    
    // Log détaillé avec info revendeur
    
    
    if (customer.isReseller) {
    }
  };

  const resetCustomerSelection = () => {
    setSelectedCustomer(null);
    setCustomerName('');
    setCustomerPhone('');
    setCustomerAddress(''); // AJOUTER cette ligne
    setFilteredCustomers([]);
    setShowCustomerSuggestions(false);
    setShowMobileCustomerSuggestions(false);
  };

  // Calculs
  const calculateSubtotal = () => {
    return cart.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  };

  const calculateTotal = () => {
  if (!cart || cart.length === 0) return 0;
  
  const subtotal = cart.reduce((sum, item) => {
    const price = parseFloat(item.price) || 0;
    const quantity = parseInt(item.quantity) || 0;
    const itemTotal = price * quantity;
    
    return sum + itemTotal;
  }, 0);
  
  const discountAmount = parseFloat(discount) || 0;
  const total = subtotal - discountAmount;
  
  
  
  return Math.max(0, total);
};

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('fr-FR', {
      minimumFractionDigits: 0
    }).format(amount || 0) + ' XOF';
  };

  // Validation et soumission
  const validateSale = () => {
    if (cart.length === 0) {
      setError('Ajoutez au moins un produit à la vente');
      return false;
    }

    if (isCredit && !customerName.trim()) {
      setError('Veuillez saisir un nom de client pour une vente à crédit');
      return false;
    }

    return true;
  };

  

  // Fonctions d'impression
  const prepareSaleDataForPrint = () => {
  // Données client
  let customerData;
  if (selectedCustomer?.id) {
    // Client existant
    customerData = {
      id: selectedCustomer.id,
      name: selectedCustomer.name,
      phone: selectedCustomer.phone || null,
      // ✅ Infos revendeur du client existant
      isReseller: selectedCustomer.isReseller || false,
      resellerDiscount: selectedCustomer.resellerDiscount || null
    };
  } else if (customerName.trim()) {
    // Nouveau client
    customerData = {
      name: customerName.trim(),
      phone: customerPhone?.trim() || null,
      // ✅ Infos revendeur pour nouveau client (depuis le formulaire)
      isReseller: isNewCustomerReseller || false,
      resellerDiscount: isNewCustomerReseller ? (parseFloat(resellerDiscountAmount) || 3000) : null
    };
  } else {
    customerData = {
      name: 'Client anonyme',
      phone: null,
      isReseller: false,
      resellerDiscount: null
    };
  }

  // ✅ CORRECTION: Articles enrichis avec tous les champs nécessaires pour l'impression
  const enrichedItems = cart.map(item => ({
    id: item.productId,
    productId: item.productId,
    productName: item.name,
    name: item.name, // Garder les deux pour compatibilité
    quantity: item.quantity,
    unitPrice: item.price,
    price: item.price, // Garder les deux pour compatibilité
    totalPrice: item.price * item.quantity,
    productType: item.productType || (item.isService ? 'SERVICE' : 'STOCKABLE'),
    isService: item.isService || item.productType === 'SERVICE',
    typeIcon: item.isService || item.productType === 'SERVICE' ? '🔧' : '📦',
    typeLabel: item.isService || item.productType === 'SERVICE' ? 'Service' : 'Produit',
    categoryName: item.categoryName || 'Non catégorisé',
    imageUrl: item.imageUrl,
    // ✅ Infos remise revendeur pour chaque item
    hasResellerDiscount: item.hasResellerDiscount || false,
    resellerDiscountAmount: item.resellerDiscountAmount || 0,
    originalPrice: item.originalPrice || item.price
  }));

  const subtotal = calculateSubtotal();
  const total = calculateTotal();
  
  // ✅ CORRECTION: Capturer la valeur actuelle du discount avant toute réinitialisation
  const currentDiscount = parseFloat(discount) || 0;
  

  return {
    customer: customerData,
    items: enrichedItems,
    paymentMethod: paymentMethod,
    isCredit: isCredit, // ✅ AJOUT: Statut crédit
    discount: currentDiscount, // ✅ CORRECTION: Utiliser la valeur capturée
    notes: notes, // ✅ AJOUT: Notes au niveau racine
    date: new Date(), // ✅ AJOUT: Date au niveau racine
    totals: {
      subtotal: subtotal,
      discount: currentDiscount, // ✅ CORRECTION: Utiliser la valeur capturée
      total: total,
      formattedSubtotal: formatCurrency(subtotal),
      formattedDiscount: formatCurrency(currentDiscount),
      formattedTotal: formatCurrency(total)
    },
    stats: {
      totalItems: enrichedItems.length,
      stockableItems: enrichedItems.filter(item => !item.isService).length,
      serviceItems: enrichedItems.filter(item => item.isService).length,
      stockableRevenue: enrichedItems
        .filter(item => !item.isService)
        .reduce((sum, item) => sum + item.totalPrice, 0),
      serviceRevenue: enrichedItems
        .filter(item => item.isService)
        .reduce((sum, item) => sum + item.totalPrice, 0)
    },
    metadata: {
      saleDate: new Date().toLocaleString('fr-FR'),
      saleNumber: null // Sera remplacé par le numéro du backend
    }
  };
};

  // const getBoutiqueInfo = () => {
  //   return {
  //     name: currentBoutique?.name ,
  //     address: currentBoutique?.address ,
  //     phone: currentBoutique?.phone ,
  //     email: currentBoutique?.email || null
  //   };
  // };

  const getBoutiqueInfo = () => {
  return {
    name: currentBoutique?.name || 'Ma Boutique',
    address: currentBoutique?.address || 'Dakar, Sénégal',
    phone: currentBoutique?.phone || '+221 XX XXX XX XX',
    phone1: currentBoutique?.phone1 || '',
    email: currentBoutique?.email || null,
    // ✅ Ajouter les données nécessaires pour le logo
    logoUrl: currentBoutique?.logoUrl || currentBoutique?.logo,
    primaryColor: currentBoutique?.primaryColor || '#3b82f6',
    secondaryColor: currentBoutique?.secondaryColor || '#1d4ed8'
  };
};

  const handlePrintTicket = async (saleData) => {
  try {
    const creatorInfo = getCreatorInfo();
    
    const result = await TicketPrintService.printTicket(
      saleData, 
      getBoutiqueInfo(), 
      creatorInfo
    );
    
    if (result.success) {
      setSuccess('Ticket imprimé avec succès !');
      setTimeout(() => setSuccess(null), 3000);
    } else {
      setError(result.message || 'Erreur lors de l\'impression');
      setTimeout(() => setError(null), 5000);
    }
  } catch (error) {
    console.error('Erreur impression:', error);
    setError('Erreur lors de l\'impression du ticket');
    setTimeout(() => setError(null), 5000);
  }
};

  const handlePreviewTicket = async (saleData) => {
  try {
    const creatorInfo = getCreatorInfo();
    
    const result = await TicketPrintService.previewTicket(
      saleData, 
      getBoutiqueInfo(), 
      creatorInfo
    );
    
    if (!result.success) {
      setError(result.message || 'Erreur lors de l\'aperçu');
      setTimeout(() => setError(null), 5000);
    }
  } catch (error) {
    console.error('Erreur aperçu:', error);
    setError('Erreur lors de l\'aperçu du ticket');
    setTimeout(() => setError(null), 5000);
  }
};

const handlePrintFromOptions = async () => {
  if (!lastSaleData) return;
  
  try {
    const creatorInfo = getCreatorInfo();
    
    const result = await TicketPrintService.printTicket(
      lastSaleData, 
      getBoutiqueInfo(), 
      creatorInfo
    );
    
    if (result.success) {
      setSuccess('Ticket imprimé avec succès !');
      setTimeout(() => setSuccess(null), 3000);
    } else {
      setError(result.message || 'Erreur lors de l\'impression');
      setTimeout(() => setError(null), 5000);
    }
  } catch (error) {
    console.error('Erreur impression:', error);
    setError('Erreur lors de l\'impression du ticket');
    setTimeout(() => setError(null), 5000);
  } finally {
    setShowPrintOptions(false);
    setLastSaleData(null);
  }
};

// ✅ NOUVELLE FONCTION À AJOUTER - Pour l'impression 58mm
const handlePrint58mm = async () => {
  if (!lastSaleData) return;
  
  try {
    const creatorInfo = getCreatorInfo(); // ✅ AJOUT: Récupérer les infos du créateur
    
    const result = await TicketPrintService.printTicket58mm(
      lastSaleData, 
      getBoutiqueInfo(),
      creatorInfo // ✅ AJOUT: Passer les infos du vendeur
    );
    
    if (result.success) {
      setSuccess('Ticket 58mm imprimé avec succès !');
      setTimeout(() => setSuccess(null), 3000);
    } else {
      setError(result.message || 'Erreur lors de l\'impression 58mm');
      setTimeout(() => setError(null), 5000);
    }
  } catch (error) {
    console.error('Erreur impression 58mm:', error);
    setError('Erreur lors de l\'impression du ticket 58mm');
    setTimeout(() => setError(null), 5000);
  } finally {
    setShowPrintOptions(false);
    setLastSaleData(null);
  }
};
// ✅ Fonction pour sauvegarder une vente en mode offline
// ✅ Fonction pour sauvegarder une vente en mode offline
const saveOfflineSale = async (saleData) => {
  try {
    // Vérifier si la DB est prête
    await offlineDB.initDatabase();
    
    const offlineSale = {
      customerName: saleData.customer?.name || customerName || 'Client Anonyme',
      customerPhone: saleData.customer?.phone || customerPhone || null,
      customerId: saleData.customer?.id || selectedCustomer?.id || null,
      items: cart.map(item => ({
        productId: item.productId,
        name: item.name,
        quantity: item.quantity,
        price: item.price,
        unitPrice: item.price
      })),
      paymentMethod: paymentMethod,
      isCredit: isCredit,
      discount: parseFloat(discount) || 0,
      notes: notes,
      subtotal: calculateSubtotal(),
      total: calculateTotal()
    };
    
    const result = await offlineDB.createOfflineSale(offlineSale);
    
    if (result) {
      return {
        success: true,
        offline: true,
        data: result
      };
    } else {
      throw new Error('Impossible de sauvegarder la vente');
    }
  } catch (error) {
    console.error('❌ Erreur sauvegarde offline:', error);
    return {
      success: false,
      offline: true,
      message: 'Erreur: ' + error.message
    };
  }
};

 const handleSubmitSale = async () => {
  if (!validateSale()) return;

  const saleDataForPrint = prepareSaleDataForPrint();
  
  try {
    setSubmitting(true);
    setError(null);

    // Préparer les données pour le backend
    let customerData = saleDataForPrint.customer;
    const saleItems = cart.map(item => ({
      productId: item.productId,
      quantity: item.quantity,
      price: item.price,
      name: item.name
    }));

    const saleData = {
      customer: customerData,
      items: saleItems,
      paymentMethod: paymentMethod,
      isCredit: isCredit,
      discount: discount,
      notes: notes?.trim() || null
    };


    let response;
    let isOfflineSale = false;

    // ✅ HYBRIDE : En ligne → backend direct, Hors ligne → sauvegarde locale
    if (navigator.onLine) {
      // MODE EN LIGNE : Envoi direct au backend
      try {
        response = await saleService.createSale(
          saleService.formatSaleForBackend(saleData)
        );
      } catch (error) {
        console.error('❌ Erreur réseau:', error);
        // Si erreur réseau, basculer en mode offline
        if (error.message?.includes('Network') || error.message?.includes('network') || !navigator.onLine) {
          response = await saveOfflineSale(saleData);
          isOfflineSale = true;
        } else {
          throw error;
        }
      }
    } else {
      // MODE HORS LIGNE : Sauvegarde locale
      response = await saveOfflineSale(saleData);
      isOfflineSale = true;
    }

    if (response.success) {
      // ✅ Message différent selon le mode
      if (isOfflineSale || response.offline) {
        setSuccess('📴 Vente sauvegardée ! Elle sera synchronisée à la reconnexion.');
      } else {
        setSuccess('✅ Vente enregistrée avec succès !');
      }
      
      // ✅ Préparer les données pour l'impression
      const printData = {
        ...saleDataForPrint,
        saleNumber: response.data?.saleNumber || response.data?.sale_number || response.data?.localId || `VENTE-${Date.now()}`,
        metadata: {
          ...saleDataForPrint.metadata,
          saleNumber: response.data?.saleNumber || response.data?.sale_number || response.data?.localId
        },
        backend: response.data,
        isOffline: isOfflineSale || response.offline
      };
      
      // Réinitialiser le formulaire
      setCart([]);
      setCustomerName('');
      setCustomerPhone('');
      setCustomerAddress('');
      setSelectedCustomer(null);
      setPaymentMethod('CASH');
      setIsCredit(false);
      setDiscount(0);
      setDiscountInput('0');
      setNotes('');
      setSearchTerm('');
      // Reset des champs revendeur
      setIsNewCustomerReseller(false);
      setResellerDiscountAmount(3000);

      // Recharger les produits pour mettre à jour les stocks
      await loadProducts();
      // Recharger les clients pour avoir le nouveau client
      await loadCustomers();
      
      // Stocker les données d'impression et montrer les options
      setLastSaleData(printData);
      setShowPrintOptions(true);
      
    } else {
      setError(response.message || 'Erreur lors de la création de la vente');
    }
    
  } catch (error) {
    console.error('❌ Erreur soumission vente:', error);
    setError(error.message || 'Erreur lors de la soumission');
  } finally {
    setSubmitting(false);
  }
};

// 3️⃣ NOUVEAU : Composant simple pour afficher les statistiques du panier
const CartSummaryStats = () => {
  const stockableItems = cart.filter(item => 
    item.productType !== 'SERVICE' && !item.isService
  );
  const serviceItems = cart.filter(item => 
    item.productType === 'SERVICE' || item.isService
  );
  
  const stockableRevenue = stockableItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  const serviceRevenue = serviceItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  
  if (cart.length === 0) return null;
  
  return (
    <div className="cart-stats mt-2 p-2 bg-light rounded">
      <div className="d-flex justify-content-between align-items-center">
        <small className="text-muted">Résumé:</small>
        <small className="fw-bold">{cart.length} article{cart.length > 1 ? 's' : ''}</small>
      </div>
      
      {stockableItems.length > 0 && (
        <div className="d-flex justify-content-between align-items-center">
          <small className="text-primary">
            📦 {stockableItems.length} produit{stockableItems.length > 1 ? 's' : ''}
          </small>
          <small className="text-primary">{formatCurrency(stockableRevenue)}</small>
        </div>
      )}
      
      {serviceItems.length > 0 && (
        <div className="d-flex justify-content-between align-items-center">
          <small className="text-info">
            🔧 {serviceItems.length} service{serviceItems.length > 1 ? 's' : ''}
          </small>
          <small className="text-info">{formatCurrency(serviceRevenue)}</small>
        </div>
      )}
    </div>
  );
};

// Nouvelles fonctions à ajouter
const handleQuantityInput = (productId, value) => {
  if (value === '') return;
  const numericValue = parseInt(value) || 1;
  const item = cart.find(item => item.productId === productId);
  if (item) {
    const validQuantity = Math.max(1, Math.min(numericValue, item.stock));
    updateCartQuantity(productId, validQuantity);
  }
};

// ✅ VERSION STABLE: Utiliser onBlur pour éviter les conflits
const handleQuantityBlur = (productId, inputValue) => {
  const newQuantity = parseInt(inputValue, 10);
  
  if (isNaN(newQuantity) || newQuantity <= 0) {
    removeFromCart(productId);
    return;
  }
  
  const item = cart.find(item => item.productId === productId);
  if (!item) return;
  
  const finalQuantity = Math.min(newQuantity, item.stock);
  
  setCart(cart.map(item =>
    item.productId === productId
      ? { ...item, quantity: finalQuantity }
      : item
  ));
  
  if (newQuantity > item.stock) {
    setError(`Stock maximum: ${item.stock}`);
    setTimeout(() => setError(null), 2000);
  }
};

  const clearSale = () => {
    setCart([]);
    setSelectedCustomer(null);
    setCustomerName('');
    setCustomerPhone('');
    setCustomerAddress(''); // AJOUTER cette ligne
    setPaymentMethod('CASH');
    setIsCredit(false);
    setDiscount(0);
    setDiscountInput('0'); // ✅ Réinitialiser l'input de remise
    setDiscountPercentage(0); // ✅ Ajouter cette ligne
    setNotes('');
    setSearchTerm('');
    setShowCustomerSuggestions(false);
    setShowMobileCustomerSuggestions(false);
    setShowCartOffcanvas(false);
    if (searchRef.current) {
      searchRef.current.focus();
    }
  };

  // ✅ AJOUT: Fonction pour récupérer les infos du créateur
const getCreatorInfo = () => {
  if (!user) return null;
  
  return {
    id: user.id,
    name: user.name || `${user.first_name || user.firstName || ''} ${user.last_name || user.lastName || ''}`.trim(),
    firstName: user.firstName,
    lastName: user.lastName,
    role: user.role
  };
};

const handleDiscountPercentageChange = (value) => {
  const numericValue = parseFloat(value) || 0;
  if (numericValue >= 0 && numericValue <= 100) {
    setDiscountPercentage(numericValue);
    // Calculer la remise fixe basée sur le pourcentage
    const subtotal = calculateSubtotal();
    const fixedDiscount = (subtotal * numericValue) / 100;
    setDiscount(fixedDiscount);
    setDiscountInput(fixedDiscount.toString());
  }
};

  // ✅ NOUVEAU: Fonction pour gérer les changements de remise
// ✅ AJOUT 3: Modifier la fonction handleDiscountChange existante
const handleDiscountChange = (value) => {
  setDiscountInput(value);
  
  // Si le champ est vide, mettre la remise à 0
  if (value === '' || value === null || value === undefined) {
    setDiscount(0);
    setDiscountPercentage(0);
    return;
  }
  
  // Convertir en nombre et valider
  const numericValue = parseFloat(value);
  if (isNaN(numericValue) || numericValue < 0) {
    setDiscount(0);
    setDiscountPercentage(0);
  } else {
    // ✅ CORRECTION : Limiter la remise au sous-total
    const subtotal = calculateSubtotal();
    const finalDiscount = Math.min(numericValue, subtotal); // Ne pas dépasser le sous-total
    
    setDiscount(finalDiscount);
    
    // ✅ Si la remise a été limitée, ajuster l'input pour refléter la vraie valeur
    if (finalDiscount !== numericValue) {
      setDiscountInput(finalDiscount.toString());
    }
    
    // Calculer le pourcentage basé sur la remise fixe
    const percentage = subtotal > 0 ? (finalDiscount / subtotal) * 100 : 0;
    setDiscountPercentage(Math.round(percentage * 100) / 100);
  }
};

const handleDiscountBlur = () => {
  const subtotal = calculateSubtotal();
  const currentDiscount = parseFloat(discountInput) || 0;
  
  if (currentDiscount > subtotal) {
    // Si la remise dépasse le sous-total, la limiter au sous-total
    setDiscount(subtotal);
    setDiscountInput(subtotal.toString());
    setDiscountPercentage(100); // 100% du sous-total
  }
};


const createNewCustomer = async () => {
  try {
    if (!customerName.trim()) {
      setError('Nom du client requis');
      return;
    }

    setLoading(true);
    const customerData = {
      name: customerName.trim(),
      phone: customerPhone.trim() || null,
      address: customerAddress.trim() || null,
      // ✅ NOUVEAU : Champs revendeur
      isReseller: isNewCustomerReseller,
      resellerDiscount: isNewCustomerReseller ? resellerDiscountAmount : 3000
    };

    
    const response = await customerService.createCustomer(customerData);
    
    if (response.success) {
      const newCustomer = customerService.formatCustomerForDisplay(response.data);
      setCustomers(prev => [newCustomer, ...prev]);
      setSelectedCustomer(newCustomer);
      
      // ✅ NOUVEAU : Reset des champs revendeur
      setIsNewCustomerReseller(false);
      setResellerDiscountAmount(3000);
      
      // Si c'est un revendeur, afficher un message
      if (newCustomer.isReseller) {
        setSuccess(`Client revendeur "${newCustomer.name}" créé avec une remise de ${newCustomer.resellerDiscount} FCFA/produit`);
        setTimeout(() => setSuccess(null), 4000);
      }
      
    } else {
      setError(response.message || 'Erreur lors de la création du client');
    }
  } catch (error) {
    console.error('❌ Erreur lors de la création du client:', error);
    setError('Erreur lors de la création du client');
  } finally {
    setLoading(false);
  }
};


  // Composant ProductCard responsive
  const ProductCard = ({ product, onClick }) => {
    const isService = product.productType === PRODUCT_TYPES.SERVICE || 
                   product.productType === 'SERVICE' ||
                   product.isService === true;
                   
  const stockValue = isService ? null : (product.stock || product.currentStock || 0);
  const isOutOfStock = !isService && stockValue <= 0;
  const isLowStock = !isService && stockValue > 0 && stockValue <= (product.minThreshold || 5);
  
  // ✅ NOUVEAU : Récupérer les infos promo
  const hasPromo = product.hasPromo || false;
  const promoPrice = product.promoPrice || null;
  const discountPercentage = product.discountPercentage || null;
  const effectivePrice = hasPromo && promoPrice ? promoPrice : product.price;
  
    return (
      <Card 
        className={`h-100 product-card ${isOutOfStock ? 'out-of-stock' : ''} ${isLowStock ? 'low-stock' : ''}`}
        style={{ cursor: isOutOfStock ? 'not-allowed' : 'pointer', position: 'relative' }}
        onClick={() => !isOutOfStock && onClick(product)}
      >
        {/* ✅ NOUVEAU : Badge PROMO */}
        {hasPromo && (
          <div 
            className="position-absolute" 
            style={{ top: '5px', left: '5px', zIndex: 10 }}
          >
            <Badge bg="danger" className="px-2 py-1" style={{ fontSize: '0.65rem' }}>
              {discountPercentage ? `-${Math.round(discountPercentage)}%` : 'PROMO'}
            </Badge>
          </div>
        )}
        
        <Card.Body className="text-center p-2 p-sm-3">
          <div className="product-image-container mb-2">
            {product.imageUrl ? (
              <img
                src={product.imageUrl}
                alt={product.name}
                className="product-image"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'block';
                }}
              />
            ) : null}
            <div 
              className="product-icon-fallback"
              style={{ display: product.imageUrl ? 'none' : 'block' }}
            >
              {product.categoryName === 'Plastique' && '🧳'}
              {product.categoryName === 'Cuir' && '💼'}
              {product.categoryName === 'Sport' && '🎒'}
              {product.categoryName === 'Femme' && '👜'}
              {!['Plastique', 'Cuir', 'Sport', 'Femme'].includes(product.categoryName) && '📦'}
            </div>
          </div>
          
          <h6 className="product-name mb-1">{product.name}</h6>
          
          {/* ✅ NOUVEAU : Affichage prix avec promo */}
          <div className="product-price mb-2">
            {hasPromo && promoPrice ? (
              <>
                <div className="text-success fw-bold">{formatCurrency(promoPrice)}</div>
                <small className="text-muted text-decoration-line-through">
                  {formatCurrency(product.price)}
                </small>
              </>
            ) : (
              <div>{formatCurrency(product.price)}</div>
            )}
          </div>
          
          {!isService && (
          <Badge 
            bg={stockValue > 5 ? 'success' : stockValue > 0 ? 'warning' : 'danger'}
            className="mb-2"
          >
            Stock: {stockValue}
          </Badge>
          )}
          {isService && (
          <Badge 
            bg={'success'}
            className="mb-2"
          >
            Disponible
          </Badge>
          )}
          {product.sku && (
            <div className="text-muted small d-none d-sm-block">SKU: {product.sku}</div>
          )}
        </Card.Body>
      </Card>
    );
  };

  // Composant CartItem responsive
  const CartItem = ({ item, onUpdate, onRemove }) => (
    <div className="cart-item mb-2">
      <div className="d-flex justify-content-between align-items-start">
        <div className="flex-grow-1">
          <div className="fw-bold text-truncate">{item.name}</div>
          <small className="text-muted">
            Qté: {item.quantity} × {formatCurrency(item.price)}
          </small>
          {/* ✅ NOUVEAU : Afficher les badges promo/revendeur */}
          <div className="d-flex gap-1 mt-1 flex-wrap">
            {item.hasPromo && (
              <Badge bg="danger" className="small" style={{fontSize: '0.65rem'}}>
                PROMO
              </Badge>
            )}
            {item.hasResellerDiscount && (
              <Badge bg="success" className="small" style={{fontSize: '0.65rem'}}>
                🏷️ -{item.resellerDiscountAmount} FCFA
              </Badge>
            )}
          </div>
        </div>
        <div className="text-end ms-2">
          <div className="fw-bold">{formatCurrency(item.price * item.quantity)}</div>
          {/* ✅ NOUVEAU : Afficher le prix original barré si remise */}
          {(item.hasPromo || item.hasResellerDiscount) && item.originalPrice > item.price && (
            <small className="text-muted text-decoration-line-through">
              {formatCurrency(item.originalPrice * item.quantity)}
            </small>
          )}
          <div className="d-flex align-items-center gap-1 mt-1">
            <Button
              size="sm"
              variant="outline-secondary"
              onClick={() => onUpdate(item.productId, item.quantity - 1)}
              className="btn-cart-control"
            >
              <Minus size={10} />
            </Button>
            <Form.Control
            type="number"
            min="1"
            onWheel={(e) => e.target.blur()} // ✅ Désactiver le scroll pour éviter les conflits  
            max={item.stock}
            defaultValue={item.quantity} // ✅ Utiliser defaultValue au lieu de value
            onBlur={(e) => handleQuantityBlur(item.productId, e.target.value)} // ✅ onBlur au lieu de onChange
            className="cart-quantity-input"
            style={{
              width: '50px',
              height: '28px',
              padding: '2px 4px',
              textAlign: 'center',
              fontSize: '12px'
            }}
          />
            <Button
              size="sm"
              variant="outline-secondary"
              onClick={() => onUpdate(item.productId, item.quantity + 1)}
              disabled={item.quantity >= item.stock}
              className="btn-cart-control"
            >
              <Plus size={10} />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
  
  // ═══════════════════════════════════════════════════════════════
  // ✅ BLOCAGE SI MODE RESTAURANT ET PAS DE SESSION
  // ═══════════════════════════════════════════════════════════════

  // 1. Chargement initial vérification session
  if (isRestaurantEnabled && sessionLoading) {
    return (
      <Container className="py-5 text-center">
        <Spinner animation="border" />
        <p className="mt-3">Vérification de la session...</p>
      </Container>
    );
  }

  // 2. Pas de session ouverte → forcer l'ouverture
  // 2. Pas de session ouverte → écran de blocage avec bouton pour ouvrir le modal
if (isRestaurantEnabled && currentSession?.id==null) {
  return (
    <>
      <Container className="py-5 text-center">
        <Lock size={48} className="text-muted mb-3" />
        <h4>Aucune session ouverte</h4>
        <p className="text-muted">
          Vous devez ouvrir une session avant de pouvoir effectuer des ventes.
        </p>
        <Button 
          variant="success" 
          size="lg" 
          onClick={() => setShowOpenSessionModal(true)}
        >
          <Lock size={16} className="me-2" />
          Ouvrir une session
        </Button>
        <div className="mt-3">
          <small className="text-muted">
            💡 Contactez votre gestionnaire si vous ne souhaitez pas utiliser le module restaurant
          </small>
        </div>
      </Container>

      <OpenSessionModal
        show={showOpenSessionModal}
        onClose={() => setShowOpenSessionModal(false)}
        onSessionOpened={handleSessionOpened}
        canCancel={true}
      />
    </>
  );
}

  // 3. Session verrouillée → bloquer
  if (isRestaurantEnabled && currentSession?.status === 'LOCKED') {
    return (
      <Container className="py-5 text-center">
        <Lock size={48} className="text-warning mb-3" />
        <h4>Session verrouillée</h4>
        <Alert variant="warning" className="d-inline-block text-start">
          Votre session <strong>{currentSession.session_number}</strong> a dépassé 24h
          et a été automatiquement verrouillée.
          <br />
          <strong>Contactez votre gestionnaire</strong> pour qu'il la ferme.
        </Alert>
      </Container>
    );
  }

  console.log('🔍 RENDER SaleInterface:', {
  isRestaurantEnabled,
  sessionLoading,
  currentSession,
  cartLength: cart.length
});

  return (
    
    <div className="pos-container">
      <Container fluid className="pos-content">


        {/* ═════════════════════════════════════════════════════ */}
        {/* ✅ BANDEAU SESSION ACTIVE (mode restaurant uniquement) */}
        {/* ═════════════════════════════════════════════════════ */}
        {isRestaurantEnabled && currentSession && currentSession.status === 'OPEN' && (
          <Alert variant="success" className="d-flex justify-content-between align-items-center py-2 mb-3">
            <div>
              <Lock size={16} className="me-2" />
              <strong>Session {currentSession.session_number}</strong>
              <span className="d-none d-md-inline">
                {' '}— Fond : {cashSessionService.formatCurrency(currentSession.opening_amount)}
                {' '}— Durée : {cashSessionService.formatDuration(currentSession.duration_minutes)}
              </span>
            </div>
            <Button
              variant="outline-warning"
              size="sm"
              onClick={() => setShowCloseSessionModal(true)}
            >
              <Unlock size={14} className="me-1" />
              <span className="d-none d-sm-inline">Fermer la session</span>
              <span className="d-sm-none">Fermer</span>
            </Button>
          </Alert>
        )}

        {/* Header responsive */}
        <div className="pos-header">
          <Row className="align-items-center">
            <Col xs={12} lg={8}>
              <div className="header-content">
                <Receipt className="header-icon" size={28} />
                <div className="header-text">
                  <h2 className="pos-title">Point de Vente</h2>
                    {/* ✅ NOUVEAU : Alerte mode offline */}
                    {isOffline && (
                      <Badge bg="warning" className="ms-2">
                        📴 Mode Hors Ligne
                      </Badge>
                    )}
                  <p className="pos-subtitle d-none d-sm-block">
                    Interface de vente rapide et intuitive
                  </p>
                </div>
              </div>
              {/* ✅ NOUVEAU : Badge d'info si restriction */}
              {user?.productAccessType !== 'ALL' && (
                <Alert variant="info" className="mb-3 d-flex align-items-center">
                  <Package size={18} className="me-2" />
                  <span>
                    Vous pouvez vendre uniquement les produits de type :{' '}
                    <Badge bg={user.productAccessType === 'STOCKABLE' ? 'primary' : 'info'}>
                      {user.productAccessType === 'STOCKABLE' ? '📦 Stockables' : '🔧 Services'}
                    </Badge>
                  </span>
                </Alert>
              )}
            </Col>
            <Col xs={12} lg={4}>
              <div className="header-actions">
                {/* Option d'impression automatique */}
                <div className="print-setting d-none d-lg-flex align-items-center me-3">
                  <Form.Check
                    type="switch"
                    id="auto-print-switch"
                    label="🖨️ Impression auto"
                    checked={printAfterSale}
                    onChange={(e) => setPrintAfterSale(e.target.checked)}
                    className="print-switch"
                  />
                </div>
                
                <Button 
                  variant="primary" 
                  className="d-lg-none cart-mobile-btn"
                  onClick={() => setShowCartOffcanvas(true)}
                >
                  <ShoppingCart size={16} className="me-1" />
                  Panier ({cart.length})
                </Button>
                
                {cart.length > 0 && (
                  <div className="total-mobile d-lg-none">
                    <span className="fw-bold text-success">
                      {formatCurrency(calculateTotal())}
                    </span>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </div>

        <Row className="g-3">
          {/* Colonne produits */}
          <Col lg={8} className="products-section">
            <Card className="products-card">
              <Card.Header className="products-header">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center gap-2">
                    <Package size={20} />
                    <span className="fw-bold">Produits Disponibles</span>
                    <Badge bg="info">{Array.isArray(products) ? products.length : 0}</Badge>
                  </div>
                  
                  <div className="view-controls d-none d-lg-flex">
                    <Button
                      size="sm"
                      variant={viewMode === 'grid' ? 'primary' : 'outline-primary'}
                      onClick={() => setViewMode('grid')}
                      className="me-1"
                    >
                      <Grid3x3 size={14} />
                    </Button>
                    <Button
                      size="sm"
                      variant={viewMode === 'list' ? 'primary' : 'outline-primary'}
                      onClick={() => setViewMode('list')}
                    >
                      <Menu size={14} />
                    </Button>
                  </div>
                </div>
              </Card.Header>
              
              <Card.Body className="products-body">
                {/* <InputGroup className="search-input mb-3">
                  <InputGroup.Text>
                    <Search size={16} />
                  </InputGroup.Text>
                  <Form.Control
                    ref={searchRef}
                    type="text"
                    placeholder="🔍 Rechercher un produit..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="search-field"
                  />
                  {searchTerm && (
                    <Button 
                      variant="outline-secondary"
                      onClick={() => setSearchTerm('')}
                    >
                      ✕
                    </Button>
                  )}
                </InputGroup> */}
                <SaleInterfaceScanner
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                  searchRef={searchRef}
                  products={products}
                  onProductScanned={handleProductScanned}
                  addToCart={addToCart}
                  placeholder="🔍 Scanner ou rechercher un produit..."
                />

                <div className="products-grid">
                  {getFilteredProducts().length === 0 ? (
                    <div className="empty-products">
                      <Package size={48} className="mb-3 text-muted" />
                      <h6>
                        {!Array.isArray(products) ? 'Chargement des produits...' : 
                         products.length === 0 ? 'Aucun produit disponible' : 
                         'Aucun produit trouvé'}
                      </h6>
                      <small className="text-muted">
                        {!Array.isArray(products) ? 'Veuillez patienter' :
                         products.length === 0 ? 'Ajoutez des produits dans la gestion des stocks' :
                         'Modifiez votre recherche'}
                      </small>
                    </div>
                  ) : (
                    <Row className="products-row">
                      {getFilteredProducts().map(product => (
                        <Col 
                          key={product.id} 
                          xs={6}
                          sm={4}
                          md={3}
                          lg={3}
                          xl={3}
                          className="product-col"
                        >
                          <ProductCard product={product} onClick={addToCart} />
                        </Col>
                      ))}
                    </Row>
                  )}
                </div>
              </Card.Body>
            </Card>
          </Col>

          {/* Colonne panier - Desktop seulement */}
          <Col lg={4} className="d-none d-lg-block cart-section">
            <div className="cart-sticky">
              {/* Client Desktop */}
              <Card className="mb-3 client-card">
                
  <Card.Header className="client-header d-flex justify-content-between align-items-center">
    <div>
      <User size={18} className="me-2" />
      {selectedCustomer ? selectedCustomer.name : customerName || 'Client'}
    </div>
    {selectedCustomer?.isReseller && (
      <Badge bg="success" className="ms-2">
        🏷️ Revendeur (-{selectedCustomer.resellerDiscount} FCFA/produit)
      </Badge>
    )}
  </Card.Header>
  <Card.Body className="client-body">
    {/* ✅ NOUVEAU : Alerte info revendeur */}
    {selectedCustomer?.isReseller && (
      <Alert variant="success" className="py-2 mb-2 small">
        <strong>🏷️ Client revendeur sélectionné</strong>
        <br />
        Une remise de <strong>{selectedCustomer.resellerDiscount} FCFA</strong> sera appliquée automatiquement sur chaque produit.
      </Alert>
    )}
    <div className="position-relative">
      <InputGroup className="mb-2">
        <InputGroup.Text>
          <User size={16} />
        </InputGroup.Text>
        <Form.Control
          type="text"
          placeholder="Nom du client (optionnel)"
          value={customerName}
          onChange={(e) => handleCustomerNameChange(e.target.value)}
          onFocus={() => {
            if (filteredCustomers.length > 0) {
              setShowCustomerSuggestions(true);
            }
          }}
        />
        {customerName && !selectedCustomer && (
          <Button
            variant="outline-primary"
            onClick={createNewCustomer}
            disabled={loading}
            title="Créer nouveau client"
          >
            {loading ? <Spinner size="sm" /> : <Plus size={16} />}
          </Button>
        )}
        {customerName && (
          <Button
            variant="outline-secondary"
            onClick={resetCustomerSelection}
          >
            ✕
          </Button>
        )}
      </InputGroup>

      {/* NOUVEAU: Champ téléphone */}
      <InputGroup className="mb-2">
        <InputGroup.Text>
          <Phone size={16} />
        </InputGroup.Text>
        <Form.Control
          type="tel"
          placeholder="Téléphone (optionnel)"
          value={customerPhone}
          onChange={(e) => setCustomerPhone(e.target.value)}
        />
      </InputGroup>

      {/* NOUVEAU: Champ adresse */}
      <InputGroup className="mb-2">
        <InputGroup.Text>
          <MapPin size={16} />
        </InputGroup.Text>
        <Form.Control
          type="text"
          placeholder="Adresse (optionnel)"
          value={customerAddress}
          onChange={(e) => setCustomerAddress(e.target.value)}
        />
      </InputGroup>

      {/* ✅ NOUVEAU: Checkbox revendeur */}
      {customerName && !selectedCustomer && (
        <div className="mb-2 p-2 bg-light rounded">
          <Form.Check
            type="checkbox"
            id="isReseller-desktop"
            label="Client revendeur"
            checked={isNewCustomerReseller}
            onChange={(e) => setIsNewCustomerReseller(e.target.checked)}
            className="mb-1"
          />
          {isNewCustomerReseller && (
            <InputGroup size="sm">
              <InputGroup.Text>Remise/produit</InputGroup.Text>
              <Form.Control
                type="number"
                value={resellerDiscountAmount}
                onChange={(e) => {
                  const val = e.target.value;
                  setResellerDiscountAmount(val === '' ? '' : (parseInt(val) || 0));
                }}
                onBlur={(e) => {
                  if (!e.target.value || e.target.value === '') {
                    setResellerDiscountAmount(3000);
                  }
                }}
                min="0"
                step="500"
                placeholder="3000"
              />
              <InputGroup.Text>FCFA</InputGroup.Text>
            </InputGroup>
          )}
        </div>
      )}

      {/* Suggestions clients Desktop */}
      {showCustomerSuggestions && filteredCustomers.length > 0 && (
        <Card className="suggestions-card">
          <ListGroup variant="flush">
            {filteredCustomers.slice(0, 3).map(customer => (
              <ListGroup.Item
                key={customer.id}
                action
                onClick={() => handleSelectCustomer(customer)}
                className="suggestion-item"
              >
                <div className="d-flex justify-content-between">
                  <div>
                    <strong>{customer.name}</strong>
                    {customer.phone && (
                      <div className="text-muted small">{customer.phone}</div>
                    )}
                    {customer.address && (
                      <div className="text-muted small">{customer.address}</div>
                    )}
                    {/* ✅ Afficher la remise revendeur */}
                    {customer.isReseller && (
                      <div className="text-success small fw-bold">
                        🏷️ Remise: -{customer.resellerDiscount} FCFA/produit
                      </div>
                    )}
                  </div>
                  <div className="d-flex flex-column gap-1 align-items-end">
                    {customer.isReseller && (
                      <Badge bg="success">
                        Revendeur
                      </Badge>
                    )}
                    <Badge bg="primary">Existant</Badge>
                  </div>
                </div>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Card>
      )}
    </div>

    <div className="client-status">
      {selectedCustomer ? (
        <small className="text-success">✅ Client existant sélectionné</small>
      ) : customerName.trim() ? (
        <small className="text-info">➕ Nouveau client sera créé</small>
      ) : (
        <small className="text-muted">👤 Vente anonyme</small>
      )}
    </div>
  </Card.Body>
</Card>

              {/* Panier Desktop */}
              <Card className="mb-3 cart-card">
                <Card.Header className="cart-header">
                  <div className="d-flex justify-content-between align-items-center">
                    <span>Panier ({cart.length} articles)</span>
                    {cart.length > 0 && (
                      <Button size="sm" variant="outline-danger" onClick={() => setCart([])}>
                        <Trash2 size={14} />
                      </Button>
                    )}
                  </div>
                </Card.Header>
                <Card.Body className="cart-body">
                  {cart.length === 0 ? (
                    <div className="empty-cart">
                      <ShoppingCart size={32} className="mb-2" />
                      <p className="mb-0">Panier vide</p>
                      <small>Cliquez sur un produit pour l'ajouter</small>
                    </div>
                  ) : (
                    <div className="cart-items">
                      {cart.map(item => (
                        <CartItem
                          key={item.productId}
                          item={item}
                          onUpdate={updateCartQuantity}
                          onRemove={removeFromCart}
                        />
                      ))}
                    </div>
                  )}
                </Card.Body>
              </Card>

              {/* Paiement Desktop */}
              {cart.length > 0 && (
                <Card className="payment-card">
                  <Card.Body>
                    <div className="payment-total">
                      <h4 className="text-success mb-0">
                        Total: {formatCurrency(calculateTotal())}
                      </h4>
                      {discount > 0 && (
                        <small className="text-muted">
                          Remise: -{formatCurrency(discount)}
                        </small>
                      )}
                    </div>

                   <div className="payment-section mb-4">

        <h5>💳 Mode de Paiement</h5>
{cart.length > 0 && (
  <Card className="payment-card">
    <Card.Body>
      

      <div className="payment-section mb-4">
        
        {/* Toggle Simple/Combiné */}
        <div className="d-flex gap-2 mb-3">
          <Button
            variant={!isMultiPaymentMode ? 'dark' : 'outline-secondary'}
            onClick={() => setIsMultiPaymentMode(false)}
            size="sm"
          >
            💵 Paiement Simple
          </Button>
          <Button
            variant={isMultiPaymentMode ? 'dark' : 'outline-secondary'}
            onClick={() => {
              setIsMultiPaymentMode(true);
              setShowMultiPaymentModal(true); // ✅ Ouvrir le modal directement
            }}
            size="sm"
          >
            🔄 Paiement Combiné
          </Button>
        </div>

        {/* Paiement Simple - Blocs Adaptés */}
        {!isMultiPaymentMode && (
          <div className="d-flex flex-wrap gap-2">
            {paymentMethods.filter((method) => {
                // Exclure MIXED
                if (method.value === "MIXED") {
                  return false;
                }
                // Exclure CREDIT si non autorisé
                if (method.value === "CREDIT") {
                  return canShowCredits(currentBoutique);
                }
                return true;
              }).map(method => (
              <button
                key={method.value}
                onClick={() => handlePaymentMethodChange(method.value)} // ✅ MODIFIÉ
                className={`btn ${paymentMethod === method.value ? 'btn-dark' : 'btn-outline-secondary'} flex-fill`}
                style={{ 
                  fontSize: '10px',
                  minHeight: '40px',
                  minWidth: '70px',
                  maxWidth: '90px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '2px',
                  padding: '6px 4px'
                }}
              >
                <span style={{ fontSize: '14px' }}>{method.icon}</span>
                <span>{method.label}</span>
              </button>
            ))}
          </div>
        )}

        {/* Paiement Combiné - Message Simple */}
      
      </div>

      {/* Section Remise Simplifiée */}
      <div className="discount-section mb-4">
        <h6 className="text-dark mb-3">Remise</h6>
        <Row className="g-3">
          <Col xs={6}>
            <Form.Label className="small text-muted">Pourcentage (%)</Form.Label>
            <Form.Control
              type="number"
              onWheel={(e) => e.target.blur()} // Désactiver le scroll pour éviter les conflits
              value={discountPercentage || ''}
              onChange={(e) => handleDiscountPercentageChange(e.target.value)}
              min="0"
              max="100"
              step="0.1"
              placeholder="0"
              className="border-secondary"
            />
          </Col>
          <Col xs={6}>
            <Form.Label className="small text-muted">Montant (XOF)</Form.Label>
            <Form.Control
              type="number"
              onWheel={(e) => e.target.blur()} // Désactiver le scroll pour éviter les conflits
              value={discountInput || ''}
              onChange={(e) => handleDiscountChange(e.target.value)}
              onBlur={handleDiscountBlur}
              min="0"
              max={calculateSubtotal()}
              placeholder="0"
              className="border-secondary"
            />
            <Form.Text className="text-muted small">
              Max: {formatCurrency(calculateSubtotal())}
            </Form.Text>
          </Col>
        </Row>
      </div>

      {/* Messages d'erreur/succès simplifiés */}
      {error && (
        <div className="alert alert-light border-start border-danger border-4 py-2 mb-3">
          <small className="text-danger">{error}</small>
        </div>
      )}

      {success && (
        <div className="alert alert-light border-start border-success border-4 py-2 mb-3">
          <Check size={14} className="me-2" />
          <small className="text-success">{success}</small>
        </div>
      )}

      {/* Bouton Final Simplifié */}
      <div className="finalize-section">
        
      </div>
    </Card.Body>
  </Card>
)}

 

  {/* Paiement Combiné */}
  {/* {isMultiPaymentMode && (
    <Card className="border-info">
      <Card.Body className="text-center">
        <div className="mb-3">
          <h6>🔄 Paiement Combiné Activé</h6>
          <p className="text-muted small mb-0">
            Répartissez le montant sur plusieurs méthodes de paiement
          </p>
        </div>
        <Button 
          variant="info" 
          onClick={handleMultiPayment}
          disabled={cart.length === 0}
        >
          <Calculator size={16} className="me-2" />
          Configurer les Paiements ({formatCurrency(calculateTotal())} FCFA)
        </Button>
      </Card.Body>
    </Card>
  )} */}
</div>



                    {error && (
                      <Alert variant="danger" className="alert-compact">
                        {error}
                      </Alert>
                    )}

                    {success && (
                      <Alert variant="success" className="alert-compact">
                        <Check size={14} className="me-1" />
                        {success}
                      </Alert>
                    )}

                    <div className="finalize-section">
                      <Button
  variant="success"
  size="lg"
  onClick={isMultiPaymentMode ? handleMultiPayment : handleSubmitSale}
  disabled={cart.length === 0 || loading}
  className="w-100"
>
  {loading ? (
    <>
      <Spinner size="sm" className="me-2" />
      Traitement...
    </>
  ) : (
    <>
      <Receipt className="me-2" size={20} />
      {isMultiPaymentMode ? 'Configurer Paiements' : 'Finaliser la Vente'}
      <Badge bg="light" text="dark" className="ms-2">
        {formatCurrency(calculateTotal())} FCFA
      </Badge>
    </>
  )}
</Button>
                    </div>
                  </Card.Body>
                </Card>
              )}
            </div>
          </Col>
        </Row>

        {/* OFFCANVAS PANIER MOBILE - Avec option impression */}
        <Offcanvas 
          show={showCartOffcanvas} 
          onHide={() => setShowCartOffcanvas(false)}
          placement="end"
          className="cart-offcanvas"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>
              <ShoppingCart size={20} className="me-2" />
              Panier ({cart.length})
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            {/* Option impression mobile */}
            <div className="print-setting-mobile mb-3">
              <Form.Check
                type="switch"
                id="auto-print-switch-mobile"
                label="🖨️ Impression automatique"
                checked={printAfterSale}
                onChange={(e) => setPrintAfterSale(e.target.checked)}
              />
            </div>

            {/* Section client mobile */}
            <Card className="mb-3">
  <Card.Header className="d-flex justify-content-between align-items-center">
    <div>
      <User size={16} className="me-2" />
      {selectedCustomer ? selectedCustomer.name : 'Client'}
    </div>
    {selectedCustomer?.isReseller && (
      <Badge bg="success" className="small">
        🏷️ Revendeur
      </Badge>
    )}
  </Card.Header>
  <Card.Body>
    {/* ✅ Alerte revendeur mobile */}
    {selectedCustomer?.isReseller && (
      <Alert variant="success" className="py-2 mb-2 small">
        <strong>🏷️ Client revendeur</strong> - Remise de <strong>{selectedCustomer.resellerDiscount} FCFA</strong>/produit
      </Alert>
    )}
    <div className="position-relative">
      <InputGroup className="mb-2">
        <InputGroup.Text>
          <User size={16} />
        </InputGroup.Text>
        <Form.Control
          type="text"
          placeholder="Nom du client (optionnel)"
          value={customerName}
          onChange={(e) => handleCustomerNameChange(e.target.value)}
          onFocus={() => {
            if (filteredCustomers.length > 0) {
              setShowMobileCustomerSuggestions(true);
            }
          }}
        />
        {customerName && !selectedCustomer && (
          <Button
            variant="outline-primary"
            onClick={createNewCustomer}
            disabled={loading}
            title="Créer nouveau client"
          >
            {loading ? <Spinner size="sm" /> : <Plus size={16} />}
          </Button>
        )}
        {customerName && (
          <Button
            variant="outline-secondary"
            onClick={resetCustomerSelection}
          >
            ✕
          </Button>
        )}
      </InputGroup>

      {/* NOUVEAU: Champ téléphone mobile */}
      <InputGroup className="mb-2">
        <InputGroup.Text>
          <Phone size={16} />
        </InputGroup.Text>
        <Form.Control
          type="tel"
          placeholder="Téléphone"
          value={customerPhone}
          onChange={(e) => setCustomerPhone(e.target.value)}
        />
      </InputGroup>

      {/* NOUVEAU: Champ adresse mobile */}
      <InputGroup className="mb-2">
        <InputGroup.Text>
          <MapPin size={16} />
        </InputGroup.Text>
        <Form.Control
          type="text"
          placeholder="Adresse"
          value={customerAddress}
          onChange={(e) => setCustomerAddress(e.target.value)}
        />
      </InputGroup>

      {/* ✅ NOUVEAU: Checkbox revendeur mobile */}
      {customerName && !selectedCustomer && (
        <div className="mb-2 p-2 bg-light rounded">
          <Form.Check
            type="checkbox"
            id="isReseller-mobile"
            label="Client revendeur"
            checked={isNewCustomerReseller}
            onChange={(e) => setIsNewCustomerReseller(e.target.checked)}
            className="mb-1"
          />
          {isNewCustomerReseller && (
            <InputGroup size="sm">
              <InputGroup.Text>Remise/produit</InputGroup.Text>
              <Form.Control
                type="number"
                value={resellerDiscountAmount}
                onChange={(e) => {
                  const val = e.target.value;
                  setResellerDiscountAmount(val === '' ? '' : (parseInt(val) || 0));
                }}
                onBlur={(e) => {
                  if (!e.target.value || e.target.value === '') {
                    setResellerDiscountAmount(3000);
                  }
                }}
                min="0"
                step="500"
                placeholder="3000"
              />
              <InputGroup.Text>FCFA</InputGroup.Text>
            </InputGroup>
          )}
        </div>
      )}

      {/* Suggestions clients mobile */}
      {showMobileCustomerSuggestions && filteredCustomers.length > 0 && (
        <Card className="suggestions-card-mobile position-absolute w-100" style={{ zIndex: 1050 }}>
          <ListGroup variant="flush">
            {filteredCustomers.slice(0, 3).map(customer => (
              <ListGroup.Item
                key={customer.id}
                action
                onClick={() => handleSelectCustomer(customer)}
                className="suggestion-item-mobile"
              >
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <strong className="d-block">{customer.name}</strong>
                    {customer.phone && (
                      <small className="text-muted">{customer.phone}</small>
                    )}
                    {customer.address && (
                      <small className="text-muted d-block">{customer.address}</small>
                    )}
                    {/* ✅ Afficher la remise revendeur */}
                    {customer.isReseller && (
                      <small className="text-success d-block fw-bold">
                        🏷️ -{customer.resellerDiscount} FCFA/produit
                      </small>
                    )}
                  </div>
                  <div className="d-flex flex-column gap-1 ms-2 align-items-end">
                    {customer.isReseller && (
                      <Badge bg="success" className="small">Revendeur</Badge>
                    )}
                    <Badge bg="primary" className="small">Existant</Badge>
                  </div>
                </div>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Card>
      )}
    </div>

    {/* Statut client mobile */}
    <div className="client-status-mobile">
      {selectedCustomer ? (
        <small className="text-success">✅ Client existant sélectionné</small>
      ) : customerName.trim() ? (
        <small className="text-info">➕ Nouveau client sera créé</small>
      ) : (
        <small className="text-muted">👤 Vente anonyme</small>
      )}
    </div>
  </Card.Body>
</Card>

            {/* Articles du panier mobile */}
            {cart.length === 0 ? (
              <div className="empty-cart">
                <ShoppingCart size={48} className="mb-3" />
                <p>Panier vide</p>
                <Button 
                  variant="primary" 
                  onClick={() => setShowCartOffcanvas(false)}
                >
                  Continuer les achats
                </Button>
              </div>
            ) : (
              <>
                <div className="cart-items-mobile">
                  {cart.map(item => (
                    <CartItem
                      key={item.productId}
                      item={item}
                      onUpdate={updateCartQuantity}
                      onRemove={removeFromCart}
                    />
                  ))}
                </div>

                {/* <div className="cart-total-mobile">
                  <h4 className="text-success">
                    Total: {formatCurrency(calculateTotal())}
                  </h4>
                </div> */}
                

               
                 <div className="payment-mobile">
{cart.length > 0 && (
  <Card className="payment-card">
    <Card.Body>
      <div className="payment-total mb-4">
        <h4 className="text-success mb-0">
          Total: {formatCurrency(calculateTotal())}
        </h4>
        {discount > 0 && (
          <small className="text-muted">
            Remise: -{formatCurrency(discount)}
          </small>
        )}
      </div>

      <div className="payment-section mb-4">
        <h5 className="text-dark mb-3">💳 Mode de Paiement</h5>
        
        {/* Toggle Simple/Combiné */}
        <div className="d-flex gap-2 mb-3">
          <Button
            variant={!isMultiPaymentMode ? 'dark' : 'outline-secondary'}
            onClick={() => setIsMultiPaymentMode(false)}
            size="sm"
          >
            💵 Paiement Simple
          </Button>
          <Button
            variant={isMultiPaymentMode ? 'dark' : 'outline-secondary'}
            onClick={() => {
              setIsMultiPaymentMode(true);
              setShowMultiPaymentModal(true); // ✅ Ouvrir le modal directement
            }}
            size="sm"
          >
            🔄 Paiement Combiné
          </Button>
        </div>

        {/* Paiement Simple - Blocs Adaptés */}
        {!isMultiPaymentMode && (
          <div className="d-flex flex-wrap gap-2">
            {paymentMethods.filter((method) => {
                // Exclure MIXED
                if (method.value === "MIXED") {
                  return false;
                }
                // Exclure CREDIT si non autorisé
                if (method.value === "CREDIT") {
                  return canShowCredits(currentBoutique);
                }
                return true;
              }).map(method => (
              <button
                key={method.value}
                onClick={() => handlePaymentMethodChange(method.value)} // ✅ MODIFIÉ
                className={`btn ${paymentMethod === method.value ? 'btn-dark' : 'btn-outline-secondary'} flex-fill`}
                style={{ 
                  fontSize: '10px',
                  minHeight: '40px',
                  minWidth: '70px',
                  maxWidth: '90px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '2px',
                  padding: '6px 4px'
                }}
              >
                <span style={{ fontSize: '14px' }}>{method.icon}</span>
                <span>{method.label}</span>
              </button>
            ))}
          </div>
        )}

        {/* Paiement Combiné - Message Simple */}
        {/* {isMultiPaymentMode && (
          <div className="border rounded p-4 text-center bg-light">
            <h6 className="text-dark mb-2">🔄 Paiement Combiné</h6>
            <p className="text-muted small mb-3">
              Répartissez le montant sur plusieurs méthodes
            </p>
            <Button 
              variant="dark"
              onClick={handleMultiPayment}
              disabled={cart.length === 0}
            >
              <Calculator size={16} className="me-2" />
              Configurer ({formatCurrency(calculateTotal())} FCFA)
            </Button>
          </div>
        )} */}
      </div>

      {/* Section Remise Simplifiée */}
      <div className="discount-section mb-4">
        <h6 className="text-dark mb-3">Remise</h6>
        <Row className="g-3">
          <Col xs={6}>
            <Form.Label className="small text-muted">Pourcentage (%)</Form.Label>
            <Form.Control
              type="number"
              onWheel={(e) => e.target.blur()} // Désactiver le scroll pour éviter les conflits
              value={discountPercentage || ''}
              onChange={(e) => handleDiscountPercentageChange(e.target.value)}
              min="0"
              max="100"
              step="0.1"
              placeholder="0"
              className="border-secondary"
            />
          </Col>
          <Col xs={6}>
            <Form.Label className="small text-muted">Montant (XOF)</Form.Label>
            <Form.Control
              type="number"
              onWheel={(e) => e.target.blur()} // Désactiver le scroll pour éviter les conflits
              value={discountInput || ''}
              onChange={(e) => handleDiscountChange(e.target.value)}
              onBlur={handleDiscountBlur}
              min="0"
              max={calculateSubtotal()}
              placeholder="0"
              className="border-secondary"
            />
            <Form.Text className="text-muted small">
              Max: {formatCurrency(calculateSubtotal())}
            </Form.Text>
          </Col>
        </Row>
      </div>

      {/* Messages d'erreur/succès simplifiés */}
      {error && (
        <div className="alert alert-light border-start border-danger border-4 py-2 mb-3">
          <small className="text-danger">{error}</small>
        </div>
      )}

      {success && (
        <div className="alert alert-light border-start border-success border-4 py-2 mb-3">
          <Check size={14} className="me-2" />
          <small className="text-success">{success}</small>
        </div>
      )}

      {/* Bouton Final Simplifié */}
      <div className="finalize-section">
        <Button
          variant="success"
          size="lg"
          onClick={isMultiPaymentMode ? handleMultiPayment : handleSubmitSale}
          disabled={cart.length === 0 || loading || submitting}
          className="w-100 py-3"
        >
          {loading ? (
            <>
              <Spinner size="sm" className="me-2" />
              Traitement...
            </>
          ) : (
            <>
              <Receipt className="me-2" size={20} />
              {isMultiPaymentMode ? 'Configurer Paiements' : 'Finaliser la Vente'}
              <span className="ms-2 bg-light text-dark px-2 py-1 rounded">
                {formatCurrency(calculateTotal())} FCFA
              </span>
            </>
          )}
        </Button>
      </div>
    </Card.Body>
  </Card>
)}
</div>

       

                <div className="d-grid">
                  
                </div>
              </>
            )}
          </Offcanvas.Body>
        </Offcanvas>

        {/* Modal de confirmation - AVEC option impression */}
        <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>
              <Receipt size={24} className="me-2" />
              Confirmer la vente
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="confirm-total">
              <div className="display-4 text-success">{formatCurrency(calculateTotal())}</div>
              <p className="text-muted">
                {cart.length} article{cart.length > 1 ? 's' : ''} • 
                {saleService.getPaymentMethods()?.find(m => m.value === paymentMethod)?.label || paymentMethod}
                {isCredit && ' • À crédit'}
              </p>
            </div>

            <div className="confirm-details">
              <div className="row">
                <div className="col-6">
                  <strong>Client:</strong>
                  <br />
                  {selectedCustomer ? selectedCustomer.name : customerName || 'Anonyme'}
                </div>
                <div className="col-6">
                  <strong>Articles:</strong>
                  <br />
                  {cart.map(item => (
                    <div key={item.productId} className="small">
                      {item.quantity}× {item.name}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Option impression dans modal */}
            <div className="print-option-confirm mt-3 p-3 bg-light rounded">
              <Form.Check
                type="switch"
                id="print-after-sale-confirm"
                label={`🖨️ ${printAfterSale ? 'Imprimer automatiquement' : 'Ne pas imprimer automatiquement'}`}
                checked={printAfterSale}
                onChange={(e) => setPrintAfterSale(e.target.checked)}
              />
              <small className="text-muted d-block mt-1">
                Vous pourrez toujours imprimer le ticket après la vente
              </small>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>
              Annuler
            </Button>
            <Button
              variant="success"
              onClick={handleSubmitSale}
              disabled={submitting}
            >
              {submitting ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Enregistrement...
                </>
              ) : (
                <>
                  <Check size={16} className="me-2" />
                  Confirmer la vente
                </>
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal options d'impression */}
        <Modal 
          show={showPrintOptions} 
          onHide={() => setShowPrintOptions(false)} 
          centered
          size="sm"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <Printer size={20} className="me-2" />
              Impression du ticket
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            <div className="mb-4">
              <Receipt size={48} className="text-success mb-3" />
              <h5>Vente finalisée avec succès !</h5>
              <p className="text-muted">
                Souhaitez-vous imprimer le ticket de caisse ?
              </p>
            </div>

            <div className="d-grid gap-2">
              <Button
                variant="primary"
                onClick={() => {
                  handlePrintTicket(lastSaleData);
                  setShowPrintOptions(false);
                  navigate('/sales');
                }}
                className="d-flex align-items-center justify-content-center"
              >
                <Printer size={16} className="me-2" />
                Imprimer le ticket
              </Button>
              
              <Button
                variant="outline-secondary"
                onClick={() => {
                  handlePreviewTicket(lastSaleData);
                  setShowPrintOptions(false);
                  navigate('/sales');
                }}
                className="d-flex align-items-center justify-content-center"
              >
                <Eye size={16} className="me-2" />
                Aperçu du ticket
              </Button>
              
              <Button
                variant="light"
                onClick={() => {
                  setShowPrintOptions(false);
                  navigate('/sales');
                }}
                size="sm"
              >
                Passer
              </Button>
            </div>
          </Modal.Body>
        </Modal>

        {/* Modal Paiement Multiple */}
<MultiPaymentModal
          show={showMultiPaymentModal}
          onHide={() => setShowMultiPaymentModal(false)}
          onConfirm={confirmMultiPayment}
          saleTotal={calculateTotal()}
          paymentMethods={paymentMethods}
        />

        {/* ═════════════════════════════════════════════════════ */}
        {/* ✅ MODALS SESSION (mode restaurant uniquement) */}
        {/* ═════════════════════════════════════════════════════ */}
        {isRestaurantEnabled && (
          <>
            <OpenSessionModal
              show={showOpenSessionModal}
              onClose={() => setShowOpenSessionModal(false)}
              onSessionOpened={handleSessionOpened}
              canCancel={true}
            />

            {currentSession && (
              <CloseSessionModal
                show={showCloseSessionModal}
                session={currentSession}
                onClose={() => setShowCloseSessionModal(false)}
                onSessionClosed={handleSessionClosed}
                forceMode={false}
              />
            )}
          </>
        )}

      </Container>

      {/* Styles CSS intégrés responsive */}
      <style jsx>{`
        .pos-container {
          background: #f8fafc;
          min-height: 100vh;
          padding: 1rem;
        }

        .pos-content {
          max-width: 1400px;
          margin: 0 auto;
        }

        .pos-header {
          background: white;
          border-radius: 12px;
          padding: 1.5rem;
          margin-bottom: 1.5rem;
          box-shadow: 0 2px 10px rgba(0,0,0,0.08);
        }

        .header-content {
          display: flex;
          align-items: center;
          gap: 1rem;
        }

        .header-icon {
          color: #3b82f6;
          flex-shrink: 0;
        }

        .pos-title {
          font-size: 1.8rem;
          font-weight: 700;
          color: #1a202c;
          margin: 0;
        }

        .pos-subtitle {
          color: #64748b;
          margin: 0;
          font-size: 0.9rem;
        }

        .header-actions {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          gap: 1rem;
          margin-top: 1rem;
        }

        /* Styles pour l'option d'impression */
        .print-setting {
          font-size: 0.85rem;
        }

        .print-switch .form-check-input {
          background-color: #6c757d;
          border-color: #6c757d;
        }

        .print-switch .form-check-input:checked {
          background-color: #28a745;
          border-color: #28a745;
        }

        .print-setting-mobile {
          background: #f8f9fa;
          border-radius: 8px;
          padding: 0.75rem;
          border: 1px solid #e9ecef;
        }

        .cart-quantity-input {
  border: 1px solid #d1d5db !important;
  border-radius: 4px !important;
}

.cart-quantity-input:focus {
  border-color: #3b82f6 !important;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1) !important;
}

        .print-option-confirm {
          border: 1px solid #dee2e6;
        }

        .cart-mobile-btn {
          position: relative;
        }

        .total-mobile {
          font-size: 1.1rem;
          font-weight: 600;
        }

        .products-card, .client-card, .cart-card, .payment-card {
          border: none;
          border-radius: 12px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.08);
        }

        .products-header, .client-header, .cart-header {
          background: white;
          border-bottom: 1px solid #e2e8f0;
          border-radius: 12px 12px 0 0 !important;
          padding: 1rem 1.5rem;
          font-weight: 600;
        }

        .products-body, .client-body, .cart-body {
          padding: 1.5rem;
        }

        .search-input {
          margin-bottom: 1rem;
        }

        .search-field {
          border-color: #e2e8f0;
          font-size: 1rem;
        }

        .search-field:focus {
          border-color: #3b82f6;
          box-shadow: 0 0 0 0.2rem rgba(59, 130, 246, 0.15);
        }

        .products-grid {
          max-height: 70vh;
          overflow-y: auto;
        }

        .products-row {
          margin: 0 -0.5rem;
        }

        .product-col {
          padding: 0.5rem;
          margin-bottom: 1rem;
        }

        .product-image-container {
          width: 100%;
          height: 80px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f8f9fa;
          border-radius: 8px;
          overflow: hidden;
          margin-bottom: 0.75rem;
        }

        .product-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s ease;
        }

        .product-icon-fallback {
          font-size: 2rem;
          color: #6c757d;
        }

        .product-card {
          transition: all 0.3s ease;
          border: 2px solid transparent;
          height: 100%;
        }

        .product-card:hover:not(.out-of-stock) {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(0,0,0,0.15);
          border-color: #28a745;
        }

        .product-card:hover:not(.out-of-stock) .product-image {
          transform: scale(1.05);
        }

        .product-card.out-of-stock {
          opacity: 0.6;
          background-color: #f8f9fa;
        }

        .product-card.out-of-stock .product-image {
          filter: grayscale(100%);
        }

        .product-name {
          font-size: 0.85rem;
          font-weight: 600;
          color: #374151;
          line-height: 1.2;
        }

        .product-price {
          font-size: 1rem;
          font-weight: 700;
          color: #28a745;
        }

        .empty-products {
          text-align: center;
          padding: 3rem 1rem;
          color: #64748b;
        }

        .cart-sticky {
          position: sticky;
          top: 1rem;
          max-height: calc(100vh - 2rem);
          overflow-y: auto;
        }

        /* Suggestions clients - Desktop et Mobile */
        .suggestions-card, .suggestions-card-mobile {
          position: absolute;
          width: 100%;
          margin-top: 0.25rem;
          z-index: 1050;
          max-height: 200px;
          overflow-y: auto;
          box-shadow: 0 4px 20px rgba(0,0,0,0.15);
        }

        .suggestion-item, .suggestion-item-mobile {
          padding: 0.75rem;
          cursor: pointer;
          transition: background-color 0.2s;
        }

        .suggestion-item:hover, .suggestion-item-mobile:hover {
          background-color: #f8f9fa;
        }

        .client-status, .client-status-mobile {
          margin-top: 0.75rem;
        }

        .cart-body {
          max-height: 300px;
          overflow-y: auto;
        }

        .empty-cart {
          text-align: center;
          padding: 2rem 1rem;
          color: #64748b;
        }

        .cart-items {
          max-height: 250px;
          overflow-y: auto;
        }

        .cart-item {
          border-bottom: 1px solid #e2e8f0;
          padding-bottom: 0.75rem;
          margin-bottom: 0.75rem;
        }

        .cart-item:last-child {
          border-bottom: none;
          margin-bottom: 0;
        }

        .btn-cart-control {
          min-width: 28px;
          height: 28px;
          padding: 0;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .cart-quantity {
          min-width: 24px;
          text-align: center;
          font-weight: 600;
        }

        .payment-total {
          text-align: center;
          margin-bottom: 1.5rem;
        }

        .payment-methods {
          margin-bottom: 1rem;
        }

        .payment-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 0.5rem;
          margin-top: 0.5rem;
        }

        .payment-btn {
          padding: 0.5rem;
          font-size: 0.85rem;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s ease;
        }

        .discount-section {
          margin-bottom: 1rem;
        }

        .alert-compact {
          padding: 0.5rem 0.75rem;
          margin-bottom: 1rem;
          font-size: 0.85rem;
        }

        .finalize-section {
          margin-top: 1rem;
        }

        .finalize-btn {
          width: 100%;
          font-weight: 700;
          padding: 0.75rem;
        }

        /* Offcanvas mobile */
        .cart-offcanvas {
          width: 100% !important;
          max-width: 400px;
        }

        .cart-items-mobile {
          max-height: 40vh;
          overflow-y: auto;
          margin-bottom: 1rem;
        }

        .cart-total-mobile {
          text-align: center;
          margin-bottom: 1.5rem;
          padding: 1rem;
          background: #f8f9fa;
          border-radius: 8px;
        }

        .payment-mobile {
          margin-bottom: 1rem;
        }

        .payment-grid-mobile {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 0.5rem;
          margin-top: 0.5rem;
        }

        .payment-btn-mobile {
          padding: 0.5rem;
          font-size: 0.8rem;
        }

        .confirm-total {
          text-align: center;
          margin-bottom: 1.5rem;
        }

        .confirm-details {
          background: #f8f9fa;
          border-radius: 8px;
          padding: 1rem;
        }

        @media (max-width: 1200px) {
          .pos-container {
            padding: 0.75rem;
          }
          
          .pos-header {
            padding: 1.25rem;
          }
          
          .pos-title {
            font-size: 1.5rem;
          }
        }

        @media (max-width: 768px) {
          .pos-container {
            padding: 0.5rem;
          }
          
          .pos-header {
            padding: 1rem;
          }
          
          .header-content {
            flex-direction: column;
            text-align: center;
            gap: 0.5rem;
          }
          
          .pos-title {
            font-size: 1.25rem;
          }
          
          .header-actions {
            margin-top: 1rem;
            justify-content: center;
          }
          
          .product-image-container {
            height: 60px;
          }
          
          .product-name {
            font-size: 0.8rem;
          }
          
          .product-price {
            font-size: 0.9rem;
          }
          
          .products-grid {
            max-height: 60vh;
          }
        }

        @media (max-width: 576px) {
          .product-col {
            padding: 0.25rem;
          }
          
          .product-card .card-body {
            padding: 0.75rem 0.5rem;
          }
          
          .product-image-container {
            height: 50px;
            margin-bottom: 0.5rem;
          }
            
          
          .product-name {
            font-size: 0.75rem;
            margin-bottom: 0.25rem;
          }
          
          .product-price {
            font-size: 0.85rem;
          }
          
          .cart-offcanvas {
            width: 100% !important;
          }
        }

        /* Scrollbars personnalisées */
        .products-grid::-webkit-scrollbar,
        .cart-body::-webkit-scrollbar,
        .cart-items::-webkit-scrollbar,
        .cart-items-mobile::-webkit-scrollbar {
          width: 6px;
        }

        .products-grid::-webkit-scrollbar-track,
        .cart-body::-webkit-scrollbar-track,
        .cart-items::-webkit-scrollbar-track,
        .cart-items-mobile::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 3px;
        }

        .products-grid::-webkit-scrollbar-thumb,
        .cart-body::-webkit-scrollbar-thumb,
        .cart-items::-webkit-scrollbar-thumb,
        .cart-items-mobile::-webkit-scrollbar-thumb {
          background: #c1c1c1;
          border-radius: 3px;
        }
          .payment-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.5rem;
}

.payment-grid-mobile {
  display: grid;  
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem;
}

.payment-grid-mobile > .payment-btn-mobile:nth-child(7) {
  grid-column: 1 / -1; /* Le 7ème bouton prend toute la largeur */
}
        .products-grid::-webkit-scrollbar-thumb:hover,
        .cart-body::-webkit-scrollbar-thumb:hover,
        .cart-items::-webkit-scrollbar-thumb:hover,
        .cart-items-mobile::-webkit-scrollbar-thumb:hover {
          background: #a1a1a1;
        }
      `}</style>
    </div>
  );
};

export default SaleInterface;